import { Badge } from "@chakra-ui/react";
import { capitalize } from "lodash";

const statusColors = {
  pending: "yellow",
  rejected: "red",
  approved: "green",
} as const;

interface ApprovalStatusProps {
  status: keyof typeof statusColors;
}

export default function ApprovalStatus({ status }: ApprovalStatusProps) {
  return (
    <Badge colorScheme={statusColors[status]} px={2} py={1} rounded="md">
      {capitalize(status)}
    </Badge>
  );
}
